import { css } from 'styled-components';
import { Heading, Intro } from '../../../../components/ImageAndCtaCards/styles';
import spacing from '../../../../helpers/spacing';
import { fonts } from '../../fonts';

export default css`
  ${Heading} {
    ${fonts.headingMedium};
  }

  ${Intro} {
    margin-bottom: ${spacing(2)};
  }
`;
